import { getFaro } from './faro';

export type TelemetryAttrs = Record<string, string | number | boolean>;

export function track(event: string, attrs?: TelemetryAttrs): void {
  const stringAttrs = attrs
    ? Object.fromEntries(Object.entries(attrs).map(([k, v]) => [k, String(v)]))
    : undefined;
  getFaro()?.api.pushEvent(event, stringAttrs);
}

export function setTelemetryUser(user: { id: number | string; username?: string }): void {
  getFaro()?.api.setUser({ id: String(user.id), username: user.username });
}

export function clearTelemetryUser(): void {
  getFaro()?.api.resetUser();
}

export function setTelemetrySession(attributes: Record<string, string>): void {
  getFaro()?.api.setSession({ attributes });
}
